import { useEffect, useState } from "react";
import { App } from "./App";
import { prepareVkGamesLaunch } from "./vkgames-bootstrap";

type Setup =
  | { state: "loading" }
  | { state: "ready"; appId: string }
  | { state: "error"; message: string };

export function VkGamesBootstrap({ launchParams }: { launchParams: string }) {
  const [setup, setSetup] = useState<Setup>({ state: "loading" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setSetup({ state: "loading" });
    void prepareVkGamesLaunch().then(
      (appId) => {
        if (!cancelled) setSetup({ state: "ready", appId });
      },
      (error: Error) => {
        if (!cancelled)
          setSetup({
            state: "error",
            message: error.message || "Не удалось подключиться к игре.",
          });
      },
    );
    return () => { cancelled = true; };
  }, [attempt]);
  if (setup.state === "ready")
    return <App platform={{ kind: "vkgames", appId: setup.appId, launchParams }} />;
  return (
    <main className="connection-screen">
      <section className="connection-card panel" aria-live="polite">
        <span className="eyebrow">ФРОНТИР / ВКОНТАКТЕ</span>
        <h1>Последний сигнал</h1>
        <p>{setup.state === "loading" ? "Подключаем ВКонтакте…" : setup.message}</p>
        {setup.state === "error" && (
          <button className="launch-button" onClick={() => setAttempt((value) => value + 1)}>
            Повторить подключение
          </button>
        )}
      </section>
    </main>
  );
}
